import React, { Component } from 'react';
import { Waypoint } from 'react-waypoint';

import Video from './video';

class VideosSection extends Component {
  onSectionEnter() {
    const { props } = this;
    if (props.currSection !== 'videos') {
      props.history.replace({ hash: '#videos' });
    }
  }

  render() {
    const { props } = this;
    if (!props.videos || !props.videos.length) return null;

    return (
      <div id="videos" className="research-section">
        <h3>Videos</h3>

        <div>
          <Waypoint
            fireOnRapidScroll={false}
            onEnter={(e) => this.onSectionEnter(e)}
            scrollableAncestor={window}
            topOffset={1}
            bottomOffset={window.innerHeight - 50}
          >
            {this.renderVideo(props.videos[0])}
          </Waypoint>

          {props.videos.slice(1).map((video) => this.renderVideo(video))}
        </div>
      </div>
    );
  }

  renderVideo(video) {
    return (
      <div key={video.id}>
        <Video
          title={video.title}
          description={video.description}
          thumbnailUrl={video.thumbnail_url}
          videoUrl={video.video_url}
        />
      </div>
    );
  }
}

export default VideosSection;
